import { t } from 'i18next';

import { ErrorResponseErrorItemCodeDynamicAsset } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeDynamicAsset, string> => ({
  'dynamic_asset:not_found': t('dynamicAsset.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Objektet existerar inte.',
  }),
  'dynamic_asset:invalid_asset_for_duplication': t('dynamicAsset.invalidAssetForDuplication', {
    ns: 'apiErrorCodes',
    defaultValue: 'Objektet stödjer inte att dupliceras.',
  }),
  'dynamic_asset:geometry_not_found': t('dynamicAsset.geometryNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Objektet saknar koppling till en geometri.',
  }),
  'dynamic_asset:not_connected_to_file': t('dynamicAsset.notConnectedToFile', {
    ns: 'apiErrorCodes',
    defaultValue: 'Objektet saknar koppling till en fil.',
  }),
  'dynamic_asset:missing_skymap_information_model': t(
    'dynamicAsset.missingSkymapInformationModel',
    { ns: 'apiErrorCodes', defaultValue: 'Objektet saknar en geometri.' },
  ),
  'dynamic_asset:user_unauthorized': t('dynamicAsset.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Användaren har inte tillgång till objektet.',
  }),
  'dynamic_asset:unsupported_export_format': t('dynamicAsset.unsupportedExportFormat', {
    ns: 'apiErrorCodes',
    defaultValue: 'Objektet stödjer inte export till det valda formatet.',
  }),
  'dynamic_asset:invalid_asset_for_transformation': t(
    'dynamicAsset.invalidAssetForTransformation',
    {
      ns: 'apiErrorCodes',
      defaultValue: 'Objektet stödjer inte transformation med skalningsverktyget.',
    },
  ),
  'dynamic_asset:line_has_invalid_coordinates_count': t(
    'dynamicAsset.lineHasInvalidCoordinatesCount',
    { ns: 'apiErrorCodes', defaultValue: 'Linjen kräver minst två koordinater.' },
  ),
  'dynamic_asset:area_has_invalid_coordinates_count': t(
    'dynamicAsset.areaHasInvalidCoordinatesCount',
    { ns: 'apiErrorCodes', defaultValue: 'Arean kräver minst tre koordinater.' },
  ),
  'dynamic_asset:volume_incompatible_asset': t('dynamicAsset.volumeIncompatibleAsset', {
    ns: 'apiErrorCodes',
    defaultValue: 'Det valda objektet har inte stöd för den här typen av volymberäkning.',
  }),
  'dynamic_asset:volume_target_and_source_different_project': t(
    'dynamicAsset.volumeTargetAndSourceDifferentProject',
    {
      ns: 'apiErrorCodes',
      defaultValue: 'Båda ytorna för volymberäkningen måste tillhöra samma projekt.',
    },
  ),
  'dynamic_asset:volume_target_and_source_same_asset': t(
    'dynamicAsset.volumeTargetAndSourceSameAsset',
    {
      ns: 'apiErrorCodes',
      defaultValue: 'De valda ytorna för volymberäkningen får inte vara del av samma objekt.',
    },
  ),
  'dynamic_asset:prism_volume_not_found': t('dynamicAsset.prismVolumeNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Volymen existerar inte.',
  }),
});
